import { render, staticRenderFns } from "./choiceItem.vue?vue&type=template&id=4f5500f6&scoped=true"
import script from "./choiceItem.vue?vue&type=script&lang=js"
export * from "./choiceItem.vue?vue&type=script&lang=js"
import style0 from "./choiceItem.vue?vue&type=style&index=0&id=4f5500f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5500f6",
  null
  
)

export default component.exports